import { cn } from "@roman/shared/utils";
import type React from "react";

interface ArrowButton {
  onClick?: () => void;
  className?: string;
}

export const ArrowButton: React.FC<ArrowButton> = ({ onClick, className }) => {
  return (
    <button type="button" className="" onClick={onClick}>
      <img src="/assets/arrow.svg" alt="arrow button" className={cn("rotate-180", className)} />
    </button>
  );
};
